import { Button } from "@/components/ui/Button";
import type { ButtonProps } from "@/components/ui/Button";
import { useNewProject } from "@/pages/projekte/useNewProject";
import type { NewProjectCreatedHandler, NewProjectOrdnerPrefill } from "@/pages/projekte/newProjectContextValue";

export interface NewProjectButtonProps extends Omit<ButtonProps, "onClick"> {
  /** Optional: Callback nur für diese Button-Klick-Sitzung. */
  onCreated?: NewProjectCreatedHandler;
  /** Ordner aus aktuellem Listenfilter übernehmen (Projekt- oder S-Ordner). */
  ordnerPrefill?: NewProjectOrdnerPrefill | null;
  /** Sichtbarer Text. Default: "Projekt anlegen". */
  children?: ButtonProps["children"];
}

/**
 * Reusable Button, der den globalen `NewProjectDialog` öffnet.
 *
 * Nutzbar auf jeder Seite – die `NewProjectProvider` muss im umgebenden Layout
 * eingebunden sein (was im React-Pilot bereits der Fall ist).
 */
export function NewProjectButton({
  onCreated,
  ordnerPrefill,
  children = "Projekt anlegen",
  ...rest
}: NewProjectButtonProps) {
  const { open } = useNewProject();
  return (
    <Button
      {...rest}
      onClick={() =>
        open({
          onCreated,
          ordnerPrefill: ordnerPrefill ?? undefined,
        })
      }
    >
      {children}
    </Button>
  );
}
